import { initializeApp } from "firebase/app";
// import { getFirestore } from 'firebase/firestore';
// import { GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDVXeizQO8OnMxay7Mk2pi6icC7w-NiHYU",
  authDomain: "clone-1d048.firebaseapp.com",
  projectId: "clone-1d048",
  storageBucket: "clone-1d048.appspot.com",
  messagingSenderId: "854713684105",
  appId: "1:854713684105:web:96fdfd177ea6a39cdbb658",
};

export const app = initializeApp(firebaseConfig);
// const db = getFirestore(firebaseApp);
// const provider = new GoogleAuthProvider();


